<style scoped> 
    .label-custom{
        font-weight: 600;
        font-style: italic;
    }
</style>

<template>
	<div class="form-group">
        <label class="label">{{ $t("shipment_period") }}</label>
        <input
            type="text"
            class="form-control"
            v-model="shipping"
            placeholder="Enter shipping"
            :disabled="is_view"
        />
	</div>
</template>
  
<script>
export default {
    name: 'Shipping',
    props: {
        value: {
            type: [String, Number, Object],
            default: null
        },
        is_view : {
            type : Boolean,
            default : false
        }
    },
    computed: {
        shipping: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', newValue);
            }
        }
    }
}
</script>